import React, { useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import styled from "styled-components";
import { getHomeHeader } from "../../../api/axios";
import CmsCircularProgress from "../../Common/CircularProgress";
import { showToast } from "../../../Utills/toast";
import CustomTable from "../../Common/DataTable/DataTable";
// const id = 2;

export default function HeaderView() {

  const { id, partnerId } = useParams();

  const [header, setHeader] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const fetchHeader = async () => {
    setIsLoading(true);
    if (!Number(id)) {
      setIsLoading(false);
      return;
    }
    try {
      const response = await getHomeHeader(id);
      setHeader(response.data.data[0]);
    } catch (error) {
      showToast({
        type: 'error',
        message: error.response.data.message || 'Failed to fetch header. Please try again.',
      });
    } finally {
      setIsLoading(false); 
    }
  };

  useEffect(() => {
    fetchHeader();
  }, [id]);

  const columns = ["Part Name", "Content"];

  const rows = [];

if (header && Object.keys(header).length > 0) {
  rows.push(["Header Paragraph - part 1", header.header_paragraph_1]);
  rows.push(["Header Paragraph - part 2", header.header_paragraph_2]);
  rows.push(["Header Paragraph - part 3", header.header_paragraph_3]);
  rows.push(["Header Paragraph - part 4", header.header_paragraph_4]);
  rows.push([
    "Header Image",
    header.header_image ? (
      <img src={header.header_image} alt="header_img" style={{ maxWidth: 400 }} />
    ) : null,
  ]);
}

  return (
    <>
    {isLoading ? <CmsCircularProgress/> :  <ContentWrapper>
      <HomeTitle>Header Section</HomeTitle>
        <CustomTable
          columns={columns}
          rows={rows}
          isLoading={isLoading}
        />
      <ButtonWrapper>
        <Link to={`/${partnerId}/home`}>
          <Button variant="secondary">Go Back</Button>
        </Link>
        <Link to={`/${partnerId}/home/header/edit/${id}`}>
          <Button>{Number(id) ? 'Edit' : 'Add'} header section</Button>
        </Link>
      </ButtonWrapper>
    </ContentWrapper>}
    </>
   
  );
}

const ContentWrapper = styled.div`
    @media (min-width:576px) {
   padding: 1rem;
  }
    @media (min-width:768px) {
   padding: 1.5rem;
  }
   padding: .5rem;
`;

const HomeTitle = styled.h3`
  text-align: center;
  padding: 10px 0;
`;


const ButtonWrapper = styled.div`
  margin: 0 auto;
  padding-top: 40px;
  display: flex;
  gap: 5rem;
  justify-content: center;
  @media (max-width: 890px) {
   justify-content: end;
    gap: 2rem;
  }
  @media (max-width: 425px) {
    gap: 1rem;
  }
`;

